import React from 'react';
import { BackArrow } from '../icons/Icons';
import { Transition } from 'react-transition-group';

const Header = ({ pageIndex, backPage }) => {
  const headerText = () => {
    switch (pageIndex) {
      case 1:
        return 'ABOUT';
      case 2:
        return 'ABOUT';
      case 3:
        return 'DIET';
      case 4:
        return 'LIFE';
      case 5:
        return 'HEALTH';
      case 6:
        return 'EMAIL';
      default:
        break;
    }
  }

  const trackerClass = () => {
    switch (pageIndex) {
      case 1:
        return 'kids-quiz__header__tracker__active--1';
      case 2:
        return 'kids-quiz__header__tracker__active--2';
      case 3:
        return 'kids-quiz__header__tracker__active--3';
      case 4:
        return 'kids-quiz__header__tracker__active--4';
      case 5:
        return 'kids-quiz__header__tracker__active--5';
      case 6:
        return 'kids-quiz__header__tracker__active--6';
      default:
        break;
    }
  }

  return (
    <div className="kids-quiz__header">
      {pageIndex !== 1 ? <div className="back-arrow" onClick={backPage}><BackArrow /></div> : ''}
      {pageIndex < 7 ?
        <>
          <h1>Step {pageIndex} of 6: {headerText()}</h1>
          <div className="kids-quiz__header__tracker">
            <span className={`kids-quiz__header__tracker__active ${trackerClass()}`}></span>
            <span className="kids-quiz__header__tracker__gap"></span>
          </div>
        </>
        :
        <>
          <h1>RESULTS</h1>
          <div className="kids-quiz__header__tracker">
            <span className="kids-quiz__header__tracker__active kids-quiz__header__tracker__active--6"></span>
            <span className="kids-quiz__header__tracker__gap"></span>
          </div>
        </>
      }
    </div>
  );
}

export default Header;